
const EVIDENCE_FIELD: Record<string, string> = {
  "true-false": "close_ended",
  "multiple-choices": "close_ended",
  "words-selection": "word_selection",
  "words-drag-drop": "drag_drop",
  "match-options": "match_options",
  "image-labelling": "image_labels",
  "table-fill": "table_fill",
  "sequence-ordering": "sequence_ordering",
  "multiple-choices-graphical": "multiple_choice",
};

function evidenceConfig(problem: any) {
  const field = problem?.problem_type ? EVIDENCE_FIELD[problem.problem_type] : undefined;
  return field ? problem?.[field] : undefined;
}

export function problemIncludesEvidence(problem: any): boolean {
  return !!evidenceConfig(problem)?.include_evidence;
}

/**
 * Com include_evidence: is_evidence_mandatory true -> só se envia com evidência escrita;
 * false -> a evidência é opcional (pode ir a null). Sem o campo (dados antigos) conta como obrigatória.
 */
export function problemEvidenceMandatory(problem: any): boolean {
  const config = evidenceConfig(problem);
  return !!config?.include_evidence && config?.is_evidence_mandatory !== false;
}

export function storedAnswerEvidences(stored: any, assessment?: any) {
  return (
    assessment?.student_answer?.evidences ??
    assessment?.evidences ??
    stored?.student_answer?.evidences ??
    stored?.answer?.evidences ??
    stored?.answer_response?.evidences ??
    stored?.evidences ??
    null
  );
}
